import Vue from 'vue';
import Vuex from 'vuex';
import { store } from './store/store';

// Vue Components
import Base from './vue-components/Base.vue';

if (document.getElementById('perks-widget')) {
    const PerksWidget = new Vue({
        el: '#perks-widget',
        store,
        render: h => h(Base)
    });
}
